import { Link } from "react-router-dom";
import { Star, Clock, Users, Play } from "lucide-react";
import { Badge } from "../components/ui/badge";

export const CourseCard = ({ course }) => {
  const levelColors = {
    beginner: "bg-green-500/20 text-green-400 border-green-500/30",
    intermediate: "bg-yellow-500/20 text-yellow-400 border-yellow-500/30",
    advanced: "bg-red-500/20 text-red-400 border-red-500/30",
  };

  const levelLabels = {
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
  };

  const categoryColors = {
    docker: "bg-blue-500/20 text-blue-400",
    kubernetes: "bg-purple-500/20 text-purple-400",
    aws: "bg-orange-500/20 text-orange-400",
    azure: "bg-cyan-500/20 text-cyan-400",
    gcp: "bg-red-500/20 text-red-400",
    devops: "bg-primary/20 text-primary",
  };

  return (
    <Link to={`/courses/${course.course_id}`} data-testid={`course-card-${course.course_id}`}>
      <div className="group bg-card border border-border rounded-sm overflow-hidden card-hover h-full flex flex-col">
        {/* Thumbnail */}
        <div className="relative aspect-video overflow-hidden">
          <img
            src={course.thumbnail || "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800"}
            alt={course.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
          
          {/* Play Icon Overlay */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
            <div className="w-14 h-14 bg-primary/90 rounded-full flex items-center justify-center glow-green">
              <Play className="w-6 h-6 text-primary-foreground ml-1" />
            </div>
          </div>

          {/* Category Badge */}
          <div className="absolute top-3 left-3">
            <Badge className={`${categoryColors[course.category] || categoryColors.devops} border-0`}>
              {course.category.toUpperCase()}
            </Badge>
          </div>

          {/* Price */}
          <div className="absolute bottom-3 right-3">
            <span className="bg-black/80 text-primary font-heading font-bold px-2 py-1 rounded text-sm">
              ${course.price}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="p-4 flex-1 flex flex-col">
          <div className="flex items-center gap-2 mb-2">
            <Badge variant="outline" className={levelColors[course.level]}>
              {levelLabels[course.level]}
            </Badge>
          </div>

          <h3 className="font-heading font-bold text-foreground group-hover:text-primary transition-colors line-clamp-2 mb-2">
            {course.title}
          </h3>

          <p className="text-sm text-muted-foreground line-clamp-2 mb-4 flex-1">
            {course.short_description}
          </p>

          {/* Stats */}
          <div className="flex items-center justify-between text-sm text-muted-foreground pt-4 border-t border-border">
            <div className="flex items-center gap-1">
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
              <span>{course.rating.toFixed(1)}</span>
              <span className="text-muted-foreground/60">({course.reviews_count})</span>
            </div>
            <div className="flex items-center gap-1">
              <Clock className="w-4 h-4" />
              <span>{course.duration_hours}h</span>
            </div>
            <div className="flex items-center gap-1">
              <Users className="w-4 h-4" />
              <span>{course.students_count.toLocaleString()}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CourseCard;
